/* eslint-disable camelcase */
export enum FollowupOnlineSearchTypes {
  CLEAR_FILTER = '@followupOnlineSearch/CLEAR_FILTER',
  CHANGE_VALUE = '@followupOnlineSearch/CHANGE_VALUE',
  UPDATE_CURRENT_PAGE = '@followupOnlineSearch/UPDATE_CURRENT_PAGE',
  UPDATE_POSTS_PER_PAGE = '@followupOnlineSearch/UPDATE_POSTS_PER_PAGE',
  UPDATE_STORE_FIELDS = '@followupOnlineSearch/UPDATE_STORE_FIELDS',
}

export interface PublicBodyTypes {
  value: number;
  label: string;
}

export interface SituationTypes {
  value: number;
  label: string;
}

export interface DateRangeTypes {
  from: null | string;
  to: null | string;
}

export interface StatesTypes {
  value: number;
  label: string;
}

export interface RegionTypes {
  label: string;
  value: string;
}
export interface StatesRegionTypes {
  [key: string]: Array<StatesTypes>;
}

export interface CitiesTypes {
  label: string;
  value: string;
}

export interface ModalitiesTypes {
  label: string;
  value: number;
}

export interface MonitoredPortalsTypes {
  label: string;
  value: number;
  sourceClass: string;
  sourceUrl: string;
}

export interface ActivitiesTypes {
  id: number;
  codigo: string;
  nome: string;
}

export interface FollowupFiltersTypes {
  updated: boolean;
  id: string;
  publicBodyTypes: Array<PublicBodyTypes>;
  processNumber: string;
  object: string;
  address: string;
  publicBody: string;
  noticeNumber: string;
  includeDateRange: DateRangeTypes;
  states: Array<StatesTypes>;
  region: RegionTypes | null;
  cities: Array<CitiesTypes>;
  modalities: Array<ModalitiesTypes>;
  activities: Array<ActivitiesTypes>;
  summary: string;
}

export interface FollowupOnlineSearchData {
  filters: FollowupFiltersTypes;
  currentPage: number;
  postsPerPage: number;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface FollowupOnlineSearchState {
  readonly followupOnlineSearch: FollowupOnlineSearchData;
  readonly request: RequestState;
}
